import useExperiment from 'hooks/common/use-experiment';

interface UseTest10173Return {
  /** Whether any Picky Cats profile-preference variant is enabled. */
  isPickyCatsEnabled: boolean;
  /** Variant 1: Picky Cats journey V1. */
  isV1: boolean;
  /** Variant 2: Picky Cats journey V2. */
  isV2: boolean;
  /** Variant 3: Picky Cats journey V3. */
  isV3: boolean;
  /** Loading state of the experiment. */
  loading: boolean;
  /** 0 = off/control, 1 = V1, 2 = V2, 3 = V3. */
  variant: number | undefined;
}

/**
 * PT-10173: Picky Cats journey and profile preferences
 * Control (variant 0): legacy profile behavior and no maintained journey
 * Variants 1/2/3: enable profile preferences and select journey V1/V2/V3
 * @see https://petsdeli.atlassian.net/browse/PT-10173
 */
const useTest10173 = (): UseTest10173Return => {
  const { variant, loading } = useExperiment({
    baseEntryId: 'NNp6IISnNWdcL6MaxA0AcA',
  });

  const isV1 = !loading && variant === 1;
  const isV2 = !loading && variant === 2;
  const isV3 = !loading && variant === 3;

  return {
    isPickyCatsEnabled: isV1 || isV2 || isV3,
    isV1,
    isV2,
    isV3,
    loading,
    variant,
  };
};

export default useTest10173;
